import {Icon} from '@components/@icons';
import {AnimatePresence, motion, useForceUpdate} from 'framer-motion';
import {useEffect, useRef} from 'react';
import {useVideoPlayerState} from '../../useVideoPlayer';
import styles from './VideoPlayButtonCenter.module.css';

export const VideoPlayButtonCenter = () => {
    const isPlaying = useVideoPlayerState(s => s.isPlaying);
    const isFirstRender = useRef(true);

    const isPlayingPrev = useRef(isPlaying);
    const [forceRerender] = useForceUpdate();

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        const timeout = setTimeout(() => {
            isPlayingPrev.current = isPlaying;
            forceRerender();
        }, 600);

        return () => clearTimeout(timeout);
    }, [isFirstRender, isPlaying]);

    const showIcon = isPlaying !== isPlayingPrev.current;

    return (
        <AnimatePresence>
            {showIcon && (
                <motion.div
                    initial={{opacity: 0, scale: 0.8}}
                    animate={{opacity: 1, scale: 1}}
                    exit={{opacity: 0, scale: 0.8}}
                    transition={{duration: 0.3}}
                    className={styles.playButtonCenter}
                >
                    <Icon
                        name={!isPlaying ? 'pause' : 'play'}
                        color="var(--color-icon-player)"
                        size={80}
                    />
                </motion.div>
            )}
        </AnimatePresence>
    );
};
